import React from 'react';
import { AppBar, createStyles, makeStyles,  Grid, Typography } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import { useTranslation } from 'react-i18next';
import ExternalTransmissionDiscipline from '../../../../../common/Footer/ExternalTransmissionDiscipline';
import PrivacyPolicy from '../../../../../common/Footer/PrivacyPolicy';
import Terms from './Terms';
import ServiceOverview from './ServiceOverview';

const useStyles = makeStyles(() =>
  createStyles({
    root_search: {
      flexGrow: 1,
      marginTop: '150px',
      bottom: 0,
      width: '100%'
    },
    root_result: {
      flexGrow: 1,
      bottom: 0,
      width: '100%',
    },
    powered_by_text: {
      fontSize: '14px',
      padding: '5px',
    },
    link: {
      fontSize: '14px',
      padding: '5px',
      color: '#ffffff',
      textDecoration: 'underline'
    }
  }),
);

/** 旅CUBE版のフッター。 */
const TabiCubeFooter: React.FC = () => {
  const classes = useStyles({});
  const setClass = classes.root_search;

  const { t } = useTranslation();

  return (
    <div className={setClass}>
      <AppBar position="static">
        <Toolbar>
        </Toolbar>
        {/* 「Powered By 駅すぱあと」を表示する。 */}
        <Grid container justify='space-between'>
          {/* 利用規約。 */}
          <Grid item className={classes.link} >
            <Terms/>
          </Grid>
          {/* プライバシーポリシーについてのリンク。 */}
          <Grid item className={classes.link} >
            <PrivacyPolicy/>
          </Grid>
          {/* 外部通信規律についてのリンク。 */}
          <Grid item className={classes.link}>
            <ExternalTransmissionDiscipline/>
          </Grid>
          {/* サービス概要。 */}
          <Grid item className={classes.link} >
            <ServiceOverview />
          </Grid>
          <Grid item>
            <Typography className={classes.powered_by_text}>
              { t('powered_by_ekispert') }
            </Typography>
          </Grid>
        </Grid>
      </AppBar>
    </div>
  )
}

export default TabiCubeFooter;
